import React from 'react';
import PropTypes from 'prop-types';
import { ViewTitle } from 'components/ViewTitle';
import { BackButton } from 'components/Button';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import FormPosition from '../../components/Forms/FormPosition';
import * as actions from '../../redux/action';

function NewPostion({ title, subtitle }) {
  const { handleSubmit, control } = useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const renderBackbuttom = () => <BackButton />;

  const onSubmit = async (data) => {
    const confirm = window.confirm('บันทึกข้อมูล');
    if (confirm) {
      try {
        await dispatch(actions.positionCreate(data));
        await dispatch(actions.positionGetAll({}));
        alert('บันทึกสำเร็จ');
        history.goBack();
      } catch (error) {
        console.log('error');
      }
    }
  };

  const renderForm = () => (
    <di>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormPosition control={control} Controller={Controller} />
      </form>
    </di>
  );

  return (
    <div>
      <div>
        {renderTitle()}
        {renderBackbuttom()}
      </div>
      <div>{renderForm()}</div>
    </div>
  );
}

NewPostion.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
NewPostion.defaultProps = {
  title: '',
  subtitle: '',
};

export default NewPostion;
